

import { Component, OnInit, Inject } from '@angular/core';

import {  MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { FinanzasService } from 'app/finanzas/finanzas.service';

import { Usuario, Bitacora, Puc, Query } from 'app/finanzas/entidades';
import { isNumber } from 'util';
import { AggPucComponent } from '../../agg-puc/agg-puc.component';
import Swal from 'sweetalert2';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-gastos',
  templateUrl: './form-gastos.component.html',
  styleUrls: ['./form-gastos.component.css']
})

export class FormGastos implements OnInit {

  movimiento: Bitacora = new Bitacora();
  cuenta: Puc = new Puc() ;  

  checked = false;  // checkboc si aplica dependencia

  area: number;
  dependencia : number;
  dependencias: any;                 // Guarda los datos que vienen del servicio getDependencias
  subdependencias: any;                // Guarda los datos que vienen del servicio  getSubdependencias
  usuarios: Array<Usuario>;           // Guarda los datos que vienen del servicio getUsuarios

  // asignacion de lo que trae el modal
  puc = this.datos.puc;
  areas = this.datos.areas;
  gastos = this.datos.gastos;
  id_gasto = this.datos.id_gasto;    
  anio = this.datos.anio;
  mes = this.datos.mes;
  mostrarC = this.datos.mostrar


  public ngxControl = new FormControl();
  public items: any[] = this.puc;
  

  constructor(
    public dialogRef: MatDialogRef<FormGastos>,
    @Inject(MAT_DIALOG_DATA) private datos,
    public servicios: FinanzasService,
    private dialog:MatDialog    
    ) {
      this.gastos = this.datos.gastos;
      this.movimiento["tipo"] = 2;
      this.movimiento["id_empresa"] = this.datos.empresa; 
      this.movimiento['anio'] = this.anio;
      this.movimiento['mes'] = this.datos.mes;          
  }

  ngOnInit(  ){ 
    this.buscarId(this.id_gasto)
  } 
  
  buscarCodigo(  ){  
    let codigoTemp  =  this.cuenta['codigo']
    if (this.puc.find(element => element.codigo == codigoTemp)  ){        
        return true
      }
  }

  // mira en que lista esta la informacion dependiendo de la vista
  buscarId( id_gasto ){  
    let list;
    if(this.mostrarC == undefined ){
      list = this.gastos
    }
    else if( this.mostrarC == true){
      list = this.gastos
    }
    else{
      list = this.gastos[this.mes]
    }
      for (const i of list) {
        if( i.id_gasto == id_gasto ){
          this.movimiento = i 
        }
      } 
  }

  agregarPuc(): void {
    const dialogRef = this.dialog.open(AggPucComponent, {
      width: '500px',
      data :{
        empresa : this.datos.empresa,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.cuenta = result;
      this.guardarCuenta()
    });
  }

  guardarCuenta(){
    if(  this.buscarCodigo() == true ){
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'La cuenta ya existe',        
      })
    }
    else{  
      this.servicios.addCuenta(this.cuenta)
        .subscribe(  (status : Query)  =>  {
          const affectedRows = status.affectedRows
            if(affectedRows != 0){
              Swal.fire({
                type: 'success',
                title: 'La cuenta fue añadida correctamente'
            })
            this.servicios.getPuc(this.cuenta['idEmpresa']).subscribe( (resp) => {this.puc = resp}  )
          }
        else{
          Swal.fire({
              type:'error', 
              title: 'La cuenta no se pudo añadir' 
          })
        }
      })
    }
  }

  // funciones si aplica dependencia  
  public buscarDependencias():void{
    this.area = this.movimiento["id_area"]
    this.servicios.getDependencias(this.movimiento["id_area"])
      .subscribe( (resp) => {
        this.dependencias=resp
    })
  }

  public buscarSubdependencias():void{
    this.dependencia = this.movimiento["id_dependencia"];
    this.servicios.getSubdependencias(this.movimiento["id_dependencia"])
      .subscribe( (resp) => {
        this.subdependencias=resp; 
    })
  }

  public buscarUsuarios(): void {
    const selectedSubdependencia = this.movimiento['id_subdependencia'];
    if( !isNumber(selectedSubdependencia))  {
      this.servicios.getUsuarios_filter(this.area, this.dependencia  )
      .subscribe( (resp : Array<Usuario>   )   => {
        this.usuarios = resp;
      }); 
    }
    else { 
      this.servicios.getUsuarios( this.area, this.dependencia, selectedSubdependencia)
      .subscribe( (resp: Array<Usuario>) => {
        this.usuarios = resp;             
      });
    }  
  }
  
}
